import { validatePaginatedResponseWithSchema } from "@/helpers/common";
import { formatString } from "@/helpers/formatting";
import {
  accessTokenSchema,
  createdAccessTokenSchema,
} from "@/schemas/accessTokens";
import { axiosClient } from "@/services/client";
import endpoints from "@/services/endpoints";

import type { IPaginatedResponse } from "@/models/common";
import type { AccessToken, CreatedAccessToken } from "@/schemas/accessTokens";

export interface GetAccessTokensParams {
  status?: AccessToken["status"];
  page?: number;
  per_page?: number;
}

export type CreateAccessTokenPayload = Pick<
  AccessToken,
  "name" | "description" | "expires_at" | "abilities"
>;

class AccessTokensService {
  async list(params: GetAccessTokensParams = {}) {
    const response = await axiosClient.get<IPaginatedResponse<AccessToken>>(
      endpoints.ACCESS_TOKENS.ALL,
      { params }
    );

    return validatePaginatedResponseWithSchema(
      accessTokenSchema,
      response.data
    );
  }

  async create(data: CreateAccessTokenPayload) {
    const response = await axiosClient.post<{ data: CreatedAccessToken }>(
      endpoints.ACCESS_TOKENS.ALL,
      data
    );

    return createdAccessTokenSchema.parse(response.data.data);
  }

  async delete(tokenId: AccessToken["id"]) {
    await axiosClient.delete(
      formatString(endpoints.ACCESS_TOKENS.SINGLE, tokenId)
    );
  }
}

export default new AccessTokensService();
